import './App.css';
import Footer from './components/footer/Footer';
import NavBar from './components/navBar/NavBar';
import Home from './pages/home/Home';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import RequestQuote from './pages/requestquote/RequestQuote';
import NoPage from './pages/nopage/NoPage';
import Products from './pages/products/Products';
import About from './pages/about/About';
import Contact from './pages/contact/Contact';
import WhatsApp from './components/whatsApp/WhatsApp';
import Furnaces from './pages/furnaces/Furnaces';
import Metallurgicals from './pages/metallurgicals/Metallurgicals';
import Firebricks from './pages/firebricks/Firebricks';
import Castable from './pages/castable/Castable';
import Mortar from './pages/mortar/Mortar';
import Cfibre from './pages/cfibre/Cfibre';
import Insulationbrick from './pages/insulationbrick/Insulationbrick';
import Crucible from './pages/crucible/Crucible';
import Ferrosilicon from './pages/ferrosilicon/Ferrosilicon';
import Fesimagnesium from './pages/fesimagnesium/Fesimagnesium';
import { Helmet } from 'react-helmet';
import Foundryservices from './pages/foundryservices/Foundryservices';
import Manholecover from './pages/manholecover/Manholecover';
import Gullygrating from './pages/gullygrating/Gullygrating';

function App() {
  
  return (
    <>
    <Helmet>
        <title>Raydron Equipment Manufacturing</title>
        <meta name="description" content="Raydron Equipment is a subsidiary of Raydron Nigeria Limited, founded in 2016, but started operating fully as an equipment manufacturer in 2023. We operate in Lagos, Nigeria. We specialize in building industrial equipment, tools and appliances locally. The equipment we build include: Gas-fired Smelting Furnaces for melting Aluminium, Copper & Brass Oil-fired Smelting Furnaces for melting Aluminium, Copper, Brass & Cast Iron,Induction Furnaces for melting Cast Iron, Steel, and non-ferrous alloys,Plastic Extruders, Wire Extruder Presses, Wire Drawing Machines, Hydraulic Power Systems and other custom equipment as required by our clients. We also run a small foundry where we manufacture castings such as: Manhole Covers, Gully Gratings, Industrial Valves & Fittings, and other custom castings as required by our customers"/>
        <meta name="keywords" content="rotary kilns, rotary dryer, cyclones, furnaces, tilting furnace, induction furnace, crucibles, fire bricks, firebricks, refractory cement, castable refractory cement, refractory mortar, ferrosilicon, ferrochrome, ferrosilicon magnesium" />
      </Helmet>
    <div className="App">
      
      <BrowserRouter>
        <NavBar/>
        <Routes>
          <Route path ="/" element={<Home/>}></Route>
          <Route path ="/requestquote" element={<RequestQuote/>}></Route>
          <Route path ="/products" element={<Products/>}></Route>
          <Route path ="/products/furnaces" element={<Furnaces/>}></Route>
          <Route path ="/products/foundryservices" element={<Foundryservices/>}></Route>
          <Route path ="/products/foundryservices/manholecover" element={<Manholecover/>}></Route>
          <Route path ="/products/foundryservices/gullygrating" element={<Gullygrating/>}></Route>
          <Route path ="/products/metallurgicalsupplies" element={<Metallurgicals/>}></Route>
          <Route path ="/products/metallurgicalsupplies/firebricks" element={<Firebricks/>}></Route>
          <Route path ="/products/metallurgicalsupplies/castablerefractorycement" element={<Castable/>}
          ></Route>
          <Route path="/products/metallurgicalsupplies/firebrickcement" element={<Mortar/>}></Route>
          <Route path='/products/metallurgicalsupplies/ceramicfibre' element={<Cfibre/>}></Route>
          <Route path='/products/metallurgicalsupplies/insulationbrick' element={<Insulationbrick/>}></Route>
          <Route path='/products/metallurgicalsupplies/crucible' element={<Crucible/>}></Route>
          <Route path='/products/metallurgicalsupplies/ferrosilicon' element={<Ferrosilicon/>}></Route>
          <Route path='/products/metallurgicalsupplies/ferrosiliconmagnesium' element={<Fesimagnesium/>}></Route>
          <Route path ="/about" element={<About/>}></Route>
          <Route path ="/contact" element={<Contact/>}></Route>
          <Route path ="*" element={<NoPage/>}></Route>
        </Routes>
        <Footer/>
        <WhatsApp/>
      </BrowserRouter>
    </div>
    </>
  );
}

export default App;
